import React from 'react'
import Moment from 'react-moment';
import 'moment/locale/ro';

const Comment = ({image, date, name, text}) => {
    return (
        <div className="comment-item-margin">
                    <div className="clearfix">
                        <div className="lefty">
                            <img alt={'Autor'} className="img-fluid rounded-circle" src={image}/>
                        </div>                
                        <div className="righty float-left">
                            <div className="comment-date text-muted">
                                <Moment format="DD MMMM YYYY HH:mm" locale="ro" unix>
                                    { date }
                                </Moment>                 
                            </div>   
                            <div className="comment-auhor-name">
                                <span className="comment-name">{name}</span>
                            </div>
                        </div>
                    </div>
                    <div className="text-white p-2 comment-border comm-item">
                       {text}
                    </div>
        </div>
    );
}

export default Comment;


// WEBPACK FOOTER //
// ./src/SHARED/components/comments/container/comment.component.js